import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss']
})
export class GoogleMapsComponent implements OnInit {

  @Input() latLong2: any = '';
  @Input() id: string;
  @Input() createBraanchApart: boolean = false;
  @Input() editable: boolean = true;
  @Input() htmlId: string = 'map';

  @Output() eventSendCoord = new EventEmitter<string>();

  map_flag: boolean = false;
  map: google.maps.Map;
  service: google.maps.places.PlacesService;
  infowindow: google.maps.InfoWindow;
  marker: any;
  markers: any = [];

  latitude: any;
  longitude: any;

  constructor(private uService: UtilsService, private mService: MainService, private toast: ToastrService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setMapScript();
  }

  ngOnInit() {
   this.uService.updateMap$
      .subscribe(data => {
        if(data){
          this.updateMap();
        }
      });
  }

  setMapScript(){
    this.map_flag = false;
    var body = {
      "items": [
        "google_maps_api_key",
        "system_name"
      ]
    }

    var mapId = document.getElementById('google-map-script');
    if(mapId === null){
      this.mService.post_request('app-settings', body)
      .subscribe((resp: any)=>{
        if(resp.status){
          let script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = `https://maps.google.com/maps/api/js?key=${resp.items.google_maps_api_key}&libraries=places`;
          script.id = `google-map-script`;
          document.getElementsByTagName('head')[0].appendChild(script);

          script.onload = () => {
            console.log('Google Maps Script Loaded');
            this.map_flag = true;

            if(this.id != undefined){
              this.updateMap();
            }else{
              if(this.latLong2 != '' && this.latLong2 != null){
                var localLatlng = this.latLong2.split(';');

                setTimeout(() => {
                  this.initMap({lat: Number(localLatlng[0]), lng: Number(localLatlng[1])});
                  this.marker = new google.maps.Marker({
                    position: {lat: Number(localLatlng[0]), lng: Number(localLatlng[1])},
                    map: this.map,
                  });
                }, 100);
              }else{
                setTimeout(() => {
                  this.initMap();
                }, 100);
              }
            }

          };
        }else{
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          if(resp.message.includes('expirado')){
            this.uService.logOut$.next(true);
          }
        }
      })
    }else{
      this.map_flag = true;
      if(this.latLong2 != '' && this.latLong2 != null){
        var localLatlng = this.latLong2.split(';');

        setTimeout(() => {
          this.initMap({lat: Number(localLatlng[0]), lng: Number(localLatlng[1])});
          this.marker = new google.maps.Marker({
            position: {lat: Number(localLatlng[0]), lng: Number(localLatlng[1])},
            map: this.map,
          });
        }, 100);
      }
    }
  }

  initMap( latLng?: any ): void {
    console.log('init map');
    var mainDirection = <HTMLInputElement>document.getElementById('main-direction');
    var searchBox;

    if(latLng === undefined){
      latLng = {lat: -16.51391565345272, lng: -68.12850139969908};
    }
    this.map = new google.maps.Map(document.getElementById(this.htmlId) as HTMLElement, {
      center: latLng,
      zoom: 18,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM,
      },
    });

    if(this.editable){
      this.map.addListener("click", (e) => {
        this.placeMarkerAndPanTo(e.latLng);
      });
    }

    if(mainDirection !== null){
      searchBox = new google.maps.places.SearchBox(mainDirection);

      this.map.addListener("bounds_changed", () => {
        searchBox.setBounds(this.map.getBounds());
      });
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        // Clear out the old markers.
        this.markers.forEach((marker) => {
          marker.setMap(null);
        });

        if(this.marker != undefined){
          this.marker.setMap(null);
        }

        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place) => {
          if (!place.geometry || !place.geometry.location) {
            console.log("Returned place contains no geometry");
            return;
          }

          // Create a marker for each place.
          this.latLong2 = [place.geometry.location.lat(), place.geometry.location.lng()];

          this.markers.push(
            new google.maps.Marker({
              map: this.map,
              title: place.name,
              position: place.geometry.location,
            })
          );
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        this.map.fitBounds(bounds);
      });
    }
  }

  placeMarkerAndPanTo(latLng) {
    if(this.markers.length != 0){
      // Clear out the old markers.
      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
    }

    if(this.marker != undefined){
      this.marker.setMap(null);
    }
    this.marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
    });
    this.map.panTo(latLng);

    // this.uService.newShop.map = [latLng.lat(), latLng.lng()];

    if(this.createBraanchApart){
      this.eventSendCoord.emit(`${latLng.lat()};${latLng.lng()}`);
    }else{
      this.uService.newShop.map = `${latLng.lat()};${latLng.lng()}`;
    }
  }

  updateMap(){
    console.log('update map');

    var latlng: any;

    if(this.uService.newShop.map != undefined){
      latlng = this.uService.newShop.map.split(';');
      this.latitude = Number(latlng[0]);
      this.longitude = Number(latlng[1]);
    }else{
      if(this.uService.newShop.map != null){
        latlng = this.uService?.latLong2?.split(';');

        this.latitude = Number(latlng[0]);
        this.longitude = Number(latlng[1]);
      }
    }


    setTimeout(() => {
      this.initMap({lat: Number(this.latitude), lng: Number(this.longitude)});
      if(this.uService.newShop.map != undefined){
        this.marker = new google.maps.Marker({
          position: {lat: this.latitude, lng: this.longitude},
          map: this.map,
        });
      }
      if(this.uService.latLong2 != undefined){
        this.marker = new google.maps.Marker({
          position: {lat: this.latitude, lng: this.longitude},
          map: this.map,
        });
      }
    }, 10);
  }
}
